var React = require('react');

function Pdf2 (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n            .pdfSvgClass{fill:#242D3F}\n        ")),React.createElement("g",{"fill":"none","fillRule":"evenodd","opacity":".6","key":1},[React.createElement("path",{"className":"pdfSvgClass","d":"M12 10.5h1v3h-1v-3m-5 1h1v-1H7v1M20 6v12c0 1.105-.895 2-2 2H6c-1.105 0-2-.895-2-2V6c0-1.105.895-2 2-2h12c1.105 0 2 .895 2 2M9.5 10.5C9.5 9.672 8.828 9 8 9H5.5v6H7v-2h1c.828 0 1.5-.672 1.5-1.5v-1m5 0c0-.828-.672-1.5-1.5-1.5h-2.5v6H13c.828 0 1.5-.672 1.5-1.5v-3m4-1.5h-3v6H17v-2h1.5v-1.5H17v-1h1.5V9z","key":0}),React.createElement("path",{"fillRule":"nonzero","d":"M0 0H24V24H0z","key":1})])]);
}

Pdf2.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Pdf2;

Pdf2.default = Pdf2;
